export const PAGE_SIZE = 25;

export function clampPage(page, total, per = PAGE_SIZE) {
  const pages = Math.max(1, Math.ceil((total || 0) / per));
  return Math.min(Math.max(1, page), pages);
}

export function pageSlice(items, page, per = PAGE_SIZE) {
  const p = clampPage(page, (items || []).length, per);
  return (items || []).slice((p - 1) * per, p * per);
}

export default function Pager({ page, total, per = PAGE_SIZE, onChange, testid = "pager" }) {
  const pages = Math.ceil((total || 0) / per);
  if (pages <= 1) return null;
  const p = clampPage(page, total, per);
  return (
    <div className="flex items-center justify-between mt-3" data-testid={testid}>
      <p className="text-xs text-zinc-500">Page {p} of {pages} · {total} items</p>
      <div className="flex gap-2">
        <button onClick={() => onChange(p - 1)} disabled={p <= 1} data-testid={`${testid}-prev`}
          className="h-8 px-3 border border-zinc-300 text-xs font-semibold rounded-md hover:border-zinc-500 disabled:opacity-40 transition-colors duration-200">
          Previous
        </button>
        <button onClick={() => onChange(p + 1)} disabled={p >= pages} data-testid={`${testid}-next`}
          className="h-8 px-3 border border-zinc-300 text-xs font-semibold rounded-md hover:border-zinc-500 disabled:opacity-40 transition-colors duration-200">
          Next
        </button>
      </div>
    </div>
  );
}
